module.exports = __webpack_public_path__ + "img/item_Character_fluid_02c.0db5f99c.jpeg";